export const contentTableConfig = {
  title: '列表',
  propList: [
    {prop: 'channelName', label: '来源渠道', minWidth: '60'},
    {prop: 'resourcesCount', label: '资源数', minWidth: '50', sortable: true},
    {prop: 'repeatNum', label: '重复数', minWidth: '50', sortable: true},
    {prop: 'deleteNum', label: '删除数', minWidth: '50', sortable: true}
  ],
  showIndexColumn: false,
  showSelectColumn: false
}
